import { Anchor } from '@Alias/components';
import classNames from 'classnames';
import React, { ComponentPropsWithoutRef, memo, useCallback } from 'react';
import { useInteractTrack } from '../../hooks/analytics/use-interact-track';
import { COMPONENT_FOOTER } from '../../utils/components-elements';
import { TextLink, TextLinkType } from '../../web-shared/design-system/text-link/text-link';

import styles from './footer.module.sass';

export const FooterLink = memo(
  ({ className, href, children, title, ...props }: ComponentPropsWithoutRef<'a'>) => {
    const isExternal = !href?.startsWith('/');

    const { handleInteractTrack } = useInteractTrack();

    const handleClick = useCallback(() => {
      handleInteractTrack({
        element: String(title),
        component: COMPONENT_FOOTER,
      });
    }, []);

    return (
      <TextLink
        as={Anchor}
        className={classNames(styles.footerLink, className)}
        href={String(href)}
        onClick={handleClick}
        {...props}
        rel={isExternal ? 'noreferrer' : undefined}
        target={isExternal ? '_blank' : undefined}
        type={TextLinkType.STANDALONE}
      >
        {children}
      </TextLink>
    );
  },
);

FooterLink.displayName = 'FooterLink';
